import type { FC, PropsWithChildren } from 'react'
import { createContext, useContext } from 'react'

const PersistenceContext = createContext<Storage>(window.localStorage)

export const PersistenceContextProvider: FC<PropsWithChildren<{ storage: Storage }>> = ({
  children,
  storage,
}) => {
  return <PersistenceContext.Provider value={storage}>{children}</PersistenceContext.Provider>
}

export const usePersistence = () => useContext(PersistenceContext)
